import {
  createDiscount,
  createProductMonthlyDiscount,
  getDiscount,
  getProductDiscount,
  getProducts,
  updateProductMonthlyDiscount,
} from "@/fetch/fetchProduct";
import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import * as React from "react";

import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import _ from "lodash";
import moment from "moment";
const filter = createFilterOptions();

export default function CreateProductDiscountDialog(props) {
  const {
    datetime,
    open,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    onSuccess,
    fetchAll,
    selectedPromotion,
    region,
    actions,
  } = props;

  const [brandLists, setBrandLists] = React.useState({});
  const [selectedBrand, setSelectedBrand] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState({});
  const initalDiscount = null;
  const [selectedDiscount, setSelectedDiscount] =
    React.useState(initalDiscount);
  const [formValidation, setFormvalidation] = React.useState({
    product_master_id: false,
    product_discount_price: false,
    discount_id: false,
  });
  const [notAvailableDate, setNotAvailableDate] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [discountList, setDiscountList] = React.useState([]);
  const initialFormData = {
    product_master_id: null,
    pos_price: 0,
    product_discount_price: 0,
    product_discount_datetime: datetime,
    product_discount_startdate: moment().startOf("months").format("YYYY-MM-DD"),
    discount_id: null,
    product_discount_enddate: moment().endOf("month").format("YYYY-MM-DD"),
    is_active: true,
    rebate_percent: 0,
  };
  const [formData, setFormData] = React.useState(initialFormData);
  const [productLists, setProductLists] = React.useState([]);
  const [selectedRegion, setSelectedRegion] = React.useState([]);
  const reset = () => {
    setFormData(initialFormData);
    setSelectedBrand("");
    setSelectedProduct({});
    setSelectedDiscount(initalDiscount);
  };
  const getBrand = async () => {
    const { data } = await getProducts(false);
    const { data: discount } = await getDiscount();
    const filterProduct = _.filter(
      data,
      (d) => d.region_id === parseInt(region) || d.muti_region,
    );
    setDiscountList([initalDiscount, ...discount]);
    const groupByBrand = _.groupBy(filterProduct, "brand_types_name");
    setBrandLists(groupByBrand);
    setSelectedBrand(_.keys(groupByBrand)[0]);
    if (selectedPromotion.id) {
      const productList = groupByBrand[selectedPromotion.brand_types_name];
      setSelectedBrand(selectedPromotion.brand_types_name);
      setProductLists(productList);
      const findDiscount = discount.find(
        (d) => d.id === selectedPromotion.discount_id,
      );
      setSelectedDiscount(findDiscount ?? initalDiscount);
      setFormData((prev) => {
        return {
          ...prev,
          id: selectedPromotion.id,
          product_master_id: selectedPromotion.product_master_id,
          pos_price: selectedPromotion.pos_price,
          product_discount_startdate:
            selectedPromotion.product_discount_startdate,
          product_discount_enddate: selectedPromotion.product_discount_enddate,
          product_discount_price: selectedPromotion.product_discount_price,
          discount_name: selectedPromotion.discount_name,
          discount_id: selectedPromotion.discount_id,
          is_active: selectedPromotion.is_active,
          rebate_percent: selectedPromotion.rebate_percent * 100,
        };
      });
      const index = productList.findIndex(
        (product) => product.id === selectedPromotion.product_master_id,
      );
      setSelectedProduct(productList[index]);
    } else {
      setProductLists(groupByBrand[_.keys(groupByBrand)[0]]);
    }
  };

  const handleBrandOnChange = (event) => {
    setSelectedBrand(event.target.value);
    setProductLists(brandLists[event.target.value]);
    setSelectedProduct({});
    setFormData(initialFormData);
    setSelectedDiscount(initalDiscount);
  };
  const handleDiscountChange = async (value) => {
    const setDiscount = (d) => {
      setSelectedDiscount(d);
      setFormData((prev) => {
        return {
          ...prev,
          discount_id: d.id,
          product_discount_price: _.round(
            selectedProduct.product_unit_price * d.discount_percent,
            2,
          ),
        };
      });
    };
    let discount = {};
    if (value.id === "original") {
      setSelectedDiscount(initalDiscount);
      setFormData((prev) => {
        return {
          ...prev,
          discount_id: null,
          product_discount_price: 0,
        };
      });
      return false;
    } else if (value.id === "new") {
      const discount_name = value.inputValue;
      const discount_percent = await prompt("折扣百分比(%)");
      if (parseInt(discount_percent) > 0) {
        const { data } = await createDiscount(
          discount_name,
          discount_percent / 100,
        );
        discount = data[0];
        setDiscountList((prev) => {
          return [...prev, discount];
        });
      } else {
        alert("輸入錯誤");
        return false;
      }
    } else {
      discount = value;
    }
    setDiscount(discount);
  };
  const onSubmit = async () => {
    setLoading(true);
    const {
      product_discount_price,
      product_master_id,
      is_active,
      discount_id,
    } = formData;
    const selectedDateRange = enumerateDaysBetweenDates(
      formData.product_discount_startdate,
      formData.product_discount_enddate,
    );
    const difference = _.difference(selectedDateRange, notAvailableDate);
    const _formValidation = {
      product_master_id: product_master_id === null && is_active,
      discount_id: discount_id === null && is_active,
      product_discount_price:
        (product_discount_price === "" ||
          parseInt(product_discount_price) <= 0) &&
        is_active,
      product_date: difference.length !== selectedDateRange.length && is_active,
    };
    setFormvalidation(_formValidation);
    if (_.some(_formValidation)) {
      setLoading(false);
      return false;
    }
    const arrayOfFormData = _.map(selectedRegion, (region) => {
      return {
        ...formData,
        rebate_percent: formData.rebate_percent / 100,
        work_region_id: region,
      };
    });
    try {
      if (formData.id) {
        await updateProductMonthlyDiscount(arrayOfFormData, datetime);
        onSuccess(arrayOfFormData);
      } else {
        const { data } = await createProductMonthlyDiscount(arrayOfFormData);
        onSuccess([{ ...data[0] }]);
      }
      setSnackMessage(`${formData.id ? "更新" : "新增"} 成功`);
      setSnackSeverity("success");
      setSnackOpen(true);
      //await fetchAll();
    } catch (err) {
      setSnackMessage(`${formData.id ? "更新" : "新增"} 失敗`);
      setSnackSeverity("error");
      setSnackOpen(true);
    } finally {
      reset();
      setLoading(false);
      onClose();
    }
  };
  const handleProductOnChange = async (event) => {
    const index = brandLists[selectedBrand].findIndex(
      (product) => product.id === event.target.value,
    );

    const product = brandLists[selectedBrand][index];
    const date = await getNotAvailableDate(product.id, product.brand_types_id);
    setNotAvailableDate(date);

    setSelectedProduct(product);
    setFormData({
      ...formData,
      pos_price: product.product_unit_price,
      product_master_id: product.id,
      product_discount_price: selectedDiscount?.id
        ? _.round(
            product.product_unit_price * selectedDiscount.discount_percent,
            2,
          )
        : 0,
    });
    setFormvalidation({ ...formValidation, product_master_id: false });
  };

  const handleOnChange = (value, field) => {
    setFormData({ ...formData, [field]: value });
  };

  const getNotAvailableDate = async (product_id, brand_id) => {
    const { data: discount } = await getProductDiscount(
      moment().subtract(1, "year").startOf("months").format("YYYY-MM-DD"),
      "9999-12-31",
      [product_id],
      [brand_id],
      region,
    );
    let date = [];
    const productDiscounts = discount[0]?.discount_details;
    _.forEach(productDiscounts, (productDiscount) => {
      const dateArr = enumerateDaysBetweenDates(
        productDiscount.product_discount_startdate,
        productDiscount.product_discount_enddate,
      );
      date = _.concat(date, dateArr);
    });
    return _.uniq(date);
  };

  React.useEffect(() => {
    getBrand();
    async function fetchAvailableDate() {
      setSelectedRegion([parseInt(region)]);

      if (selectedPromotion.id) {
        let date = await getNotAvailableDate(
          selectedPromotion.product_master_id,
          selectedPromotion.brand_types_id,
        );

        const currentDateRange = enumerateDaysBetweenDates(
          selectedPromotion.product_discount_startdate,
          selectedPromotion.product_discount_enddate,
        );
        setNotAvailableDate(_.uniq(_.difference(date, currentDateRange)));
      }
    }
    fetchAvailableDate();
    return () => {
      console.log("cleaned up");
    };
  }, []);
  return (
    <Dialog
      open={open}
      onClose={() => {
        reset();
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>
        {selectedPromotion.id ? "更改產品折扣" : "新增產品折扣"}
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "grid",
            gridTemplateColumns: { sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="select-brands-label">品牌</InputLabel>
            <Select
              required
              disabled={selectedPromotion.brand_types_name ? true : false}
              id="brand"
              name="brand"
              label="Brand"
              labelId="select-brands-label"
              value={selectedBrand ?? ""}
              onChange={handleBrandOnChange}
            >
              {_.map(brandLists, (brand, key) => (
                <MenuItem key={key} value={key}>
                  {key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth error={formValidation.product_master_id}>
            <InputLabel id="select-products-label">產品名稱</InputLabel>
            <Select
              required
              id="product"
              name="product"
              disabled={selectedPromotion.product_master_id ? true : false}
              labelId="select-products-label"
              label="產品名稱"
              value={selectedProduct?.id ?? ""}
              onChange={handleProductOnChange}
            >
              {_.map(productLists, (product, key) => (
                <MenuItem key={key} value={product.id}>
                  {product.product_name}
                </MenuItem>
              ))}
            </Select>
            {formValidation.product_master_id && (
              <FormHelperText>產品不能為空</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth>
            <TextField
              disabled
              id="product_unit_price"
              name="product_unit_price"
              label="產品單價價錢"
              value={selectedProduct?.product_unit_price ?? 0}
              InputProps={{
                readOnly: true,
              }}
            ></TextField>
          </FormControl>
          <FormControl fullWidth>
            <TextField
              id="pos_price"
              name="pos_price"
              label="POS單價價錢"
              value={formData.pos_price}
              onChange={(event) =>
                handleOnChange(event.target.value, "pos_price")
              }
            ></TextField>
          </FormControl>
          <FormControl fullWidth error={formValidation.product_discount_price}>
            <TextField
              error={formValidation.product_discount_price}
              required
              id="product_discount_price"
              name="product_discount_price"
              label="產品單價折扣"
              disabled={!formData.product_master_id}
              type="number"
              value={formData.product_discount_price ?? 0}
              onChange={(event) =>
                handleOnChange(event.target.value, "product_discount_price")
              }
            ></TextField>
            {formValidation.product_discount_price && (
              <FormHelperText>產品單價折扣不能為空或0</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth>
            <Autocomplete
              required
              disableClearable
              disabled={!formData.product_master_id}
              onChange={(event, newValue) => {
                handleDiscountChange(newValue);
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some(
                  (option) => inputValue === option?.discount_name,
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({
                    inputValue,
                    id: "new",
                    discount_name: `新增 "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              value={selectedDiscount}
              id="select-discount"
              options={discountList}
              getOptionLabel={(option) => {
                return `${option?.discount_name}`;
              }}
              selectOnFocus
              handleHomeEndKeys
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    {option?.discount_name}
                  </li>
                );
              }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={formValidation.discount_id}
                  helperText={formValidation.discount_id ? "折扣不能為空" : ""}
                  label="折扣"
                />
              )}
            />
          </FormControl>
          {actions?.rebateSetting && (
            <FormControl fullWidth>
              <InputLabel htmlFor="rebate_percent">Rebate</InputLabel>
              <OutlinedInput
                label="Rebate"
                id="rebate_percent"
                type="number"
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                aria-describedby="rebate_percent"
                inputProps={{
                  "aria-label": "percent",
                }}
                value={formData.rebate_percent}
                onChange={(event) => {
                  setFormData((prev) => {
                    return {
                      ...prev,
                      rebate_percent: event.target.value,
                    };
                  });
                }}
              />
            </FormControl>
          )}
          <FormControl fullWidth error={formValidation.product_date}>
            <DatePicker
              error
              required
              disabled={!formData.product_master_id}
              id="product_discount_startdate"
              name="product_discount_startdate"
              label="開始日期"
              renderInput={(params) => (
                <TextField {...params} sx={{ width: "100%" }} />
              )}
              value={formData.product_discount_startdate}
              onChange={(value) =>
                handleOnChange(
                  moment(value).format("YYYY-MM-DD"),
                  "product_discount_startdate",
                )
              }
              renderDay={(day, _value, DayComponentProps) => {
                const currentDay = day.format("YYYY-MM-DD");
                return (
                  <PickersDay
                    style={{
                      color: notAvailableDate.includes(currentDay)
                        ? "red"
                        : "black",
                    }}
                    {...DayComponentProps}
                    disabled={notAvailableDate.includes(currentDay)}
                  />
                );
              }}
            ></DatePicker>
            {formValidation.product_date && (
              <FormHelperText>日子重複</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth error={formValidation.product_date}>
            <DatePicker
              required
              disabled={!formData.product_master_id}
              id="product_discount_enddate"
              name="product_discount_enddate"
              label="結束日期"
              minDate={moment(formData.product_discount_startdate)}
              value={formData.product_discount_enddate}
              renderInput={(params) => (
                <TextField {...params} sx={{ width: "100%" }} />
              )}
              renderDay={(day, _value, DayComponentProps) => {
                const currentDay = day.format("YYYY-MM-DD");
                return (
                  <PickersDay
                    style={{
                      color: notAvailableDate.includes(currentDay)
                        ? "red"
                        : "black",
                    }}
                    {...DayComponentProps}
                    disabled={notAvailableDate.includes(currentDay)}
                  />
                );
              }}
              onChange={(value) =>
                handleOnChange(
                  moment(value).format("YYYY-MM-DD"),
                  "product_discount_enddate",
                )
              }
            ></DatePicker>
            {formValidation.product_date && (
              <FormHelperText>日子重複</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="select-brands-label">狀態</InputLabel>
            <Select
              required
              disabled={!formData.product_master_id}
              id="brand"
              name="brand"
              label="Brand"
              labelId="select-brands-label"
              value={formData.is_active ?? true}
              onChange={(e) => {
                setFormData((prev) => {
                  return {
                    ...prev,
                    is_active: !prev.is_active,
                  };
                });
              }}
            >
              <MenuItem key={"on"} value={true}>
                開啟
              </MenuItem>
              <MenuItem key={"off"} value={false}>
                關閉
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            reset();
            onClose();
          }}
        >
          取消
        </Button>
        <Button disabled={loading} onClick={onSubmit} type="submit">
          {selectedPromotion.id ? "更新" : "新增"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
